module.exports = __webpack_public_path__ + "02b0fdeda5034f457fdcffedbc3414f1.svg";